import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import "./style.scss";
import {useNavigate} from "react-router";
import {ReactComponent as ArrowIcon} from "../../assets/icons/arrow2.svg";
import Dialog from "../Dialog";
import orderStore from "../../stores/order";
import {observer} from "mobx-react";
import {ApiGeneral_ScanArrowDirection} from "../../@types/enums/styles";
import useLayoutStyles from "../../hooks/styles";

export interface FooterCustomerProps {
    isLogIntoAccount: boolean;
    goNext: () => {};
}

const FooterCustomer = ({isLogIntoAccount, goNext}: FooterCustomerProps) => {
    const [t] = useTranslation();
    const navigate = useNavigate();
    const styles = useLayoutStyles();

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const goBack = () => {
        navigate("/");
    }

    const skip = () => {
        setIsOpen(true);
    }

    const closeConfirmation = () => {
        setIsOpen(false);
    }

    return <>
        <div className={`FooterCustomerSpace ${isLogIntoAccount ? "big" : "small"}`}/>
        <div className="FooterCustomer">
            {!isLogIntoAccount
                ? <div className="button" onClick={goBack}>{t("back")}</div>
                : <div>
                    <div className="buttons">
                        <div className="button" onClick={skip}>{t("skip")}</div>
                        <div className={`button dark ${!orderStore.customerCode ? "disable" : ""}`}
                             onClick={goNext}>{t("continue")}</div>
                    </div>
                    {styles?.general.scannerArrowDirection === ApiGeneral_ScanArrowDirection.NO
                        ? null
                        : <div className="scan">
                                <div className="title">{t("scanQR")}</div>
                                <div className="description">{t("scanQRDescription")}</div>
                                <ArrowIcon className={`arrow ${styles?.general.scannerArrowDirection}`} />
                            </div>
                    }
                    <Dialog open={isOpen} title={t("customerConfirmationTitle")} text={t("customerConfirmationText")}
                            onClose={closeConfirmation}/>
                </div>
            }
        </div>
    </>
}

export default observer(FooterCustomer);
